import { LogoMark } from "./Logo";

export const Footer = () => (
  <footer className="border-t border-violet-500/20 py-12" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col md:flex-row gap-6 items-start md:items-center justify-between">
      <div className="flex items-center gap-3">
        <LogoMark className="w-8 h-8" />
        <span className="font-display uppercase tracking-[0.2em] text-sm">Rahsia Trading</span>
      </div>
      <div className="flex items-center gap-6 text-sm text-violet-200/80">
        <a href="https://t.me/rahsiatradingsecret" target="_blank" rel="noopener noreferrer" data-testid="footer-telegram-link" className="hover:text-white transition-colors">Telegram</a>
        <a href="/admin" data-testid="footer-admin-link" className="hover:text-white transition-colors">Admin</a>
        <span>© 2026 Rahsia Trading</span>
      </div>
    </div>
  </footer>
);
